import script from "./Tax.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tax.vue?vue&type=script&setup=true&lang=ts"

import "./Tax.vue?vue&type=style&index=0&id=6a1581a8&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a1581a8"]])

export default __exports__